import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';
import { LearnLayout } from '../[[...slug]]';

// Build the page using the utility
const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'LEARN',
    LayoutComponent: LearnLayout,
    ContentComponent: AuthorPage,
});

// Next.js expects named exports, so we use a wrapper
export { getStaticProps, getStaticPaths };

export default Page;
